import { collection, getDocs, updateDoc, deleteDoc, doc, query, orderBy, writeBatch, setDoc } from 'firebase/firestore';
import { db } from '../config/firebase/firebaseConfig';
import { FAQModel } from '../types/faq';

const FAQS_COLLECTION = 'faqs';

export class FAQService {
  static async loadFAQs(): Promise<FAQModel[]> {
    try {
      const faqsQuery = query(
        collection(db, FAQS_COLLECTION),
        orderBy('order', 'asc')
      );

      const snapshot = await getDocs(faqsQuery);
      const faqs: FAQModel[] = [];

      snapshot.forEach((doc) => {
        const data = doc.data();
        faqs.push({
          id: data.id || doc.id,
          question: data.question,
          answer: data.answer,
          order: data.order,
        });
      });

      return faqs;
    } catch (error) {
      console.error('Error loading FAQs:', error);
      throw error;
    }
  }

  static async createFAQ(faq: FAQModel): Promise<void> {
    try {
      console.log('Creating FAQ with data:', faq);
      const docRef = doc(db, FAQS_COLLECTION, faq.id);
      const dataToSave = {
        id: faq.id,
        question: faq.question,
        answer: faq.answer,
        order: faq.order,
      };
      console.log('Saving to Firestore:', dataToSave);
      await setDoc(docRef, dataToSave);
      console.log('FAQ created successfully with ID:', faq.id);
    } catch (error) {
      console.error('Error creating FAQ:', error);
      throw error;
    }
  }

  static async updateFAQ(faq: FAQModel): Promise<void> {
    try {
      const docRef = doc(db, FAQS_COLLECTION, faq.id);
      await updateDoc(docRef, {
        id: faq.id,
        question: faq.question,
        answer: faq.answer,
        order: faq.order,
      });
    } catch (error) {
      console.error('Error updating FAQ:', error);
      throw error;
    }
  }

  static async deleteFAQ(faqId: string): Promise<void> {
    try {
      const docRef = doc(db, FAQS_COLLECTION, faqId);
      await deleteDoc(docRef);
    } catch (error) {
      console.error('Error deleting FAQ:', error);
      throw error;
    }
  }

  static async updateFAQOrder(faqs: FAQModel[]): Promise<void> {
    try {
      const batch = writeBatch(db);

      faqs.forEach((faq, index) => {
        const docRef = doc(db, FAQS_COLLECTION, faq.id);
        batch.update(docRef, { order: index, id: faq.id });
      });

      await batch.commit();
    } catch (error) {
      console.error('Error updating FAQ order:', error);
      throw error;
    }
  }

  static async getNextOrder(): Promise<number> {
    try {
      const faqs = await this.loadFAQs();
      if (faqs.length === 0) return 0;
      return Math.max(...faqs.map(faq => faq.order)) + 1;
    } catch (error) {
      console.error('Error getting next order:', error);
      return 0;
    }
  }
}